module.exports = __webpack_public_path__ + "img/icon_terug.1289ab6c.svg";